// extracted by mini-css-extract-plugin
module.exports = {"activeRoute":"AppHeader_activeRoute__2zEmo"};